import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Route,
  Switch,
} from 'react-router-dom';
import Admission from './Admission.route';
import Login from '../pages/Login.page';
import Dashboard from './Dashboard.route';
// import NotFound from '../pages/others/NotFound.page';
import { Loading } from '../components/base';
import { initialSetup } from '../states/thunks/common.thunk';
import { setupUser } from '../states/thunks/auth.thunk';

class App extends PureComponent {
  async componentDidMount() {
    const {
      handleInitialSetup,
      handleSetupUser,
      history,
      location,
    } = this.props;
    handleInitialSetup();
    await handleSetupUser(history.replace, location.pathname);
  }

  render() {
    const { appSetup, loading } = this.props;
    if (appSetup) {
      return (
        <div>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/admission" component={Admission} />
            <Route path="/login" component={Login} />
            <Route path="/dashboard" component={Dashboard} />
            {/* <Route name="Not Found" component={NotFound} /> */}
          </Switch>
          <Loading white full loading={loading} />
        </div>
      );
    }
    return (
      <Loading white full alwaysShow />
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetup: state.appSetup,
    loading: state.loading,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleInitialSetup: () => dispatch(initialSetup()),
    handleSetupUser: (replace, pathname) => dispatch(setupUser(replace, pathname)),
  };
}

App.propTypes = {
  appSetup: PropTypes.bool,
  loading: PropTypes.object.isRequired,
  handleInitialSetup: PropTypes.func.isRequired,
  handleSetupUser: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
App.defaultProps = {
  appSetup: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
